(function () {
  if (window.TSDeliveryPromise) return;

  // England and Wales bank holidays from https://www.gov.uk/bank-holidays.json.
  // Add the next year's dates before the last one here passes.
  var BANK_HOLIDAYS = [
    "2026-01-01", "2026-04-03", "2026-04-06", "2026-05-04", "2026-05-25",
    "2026-08-31", "2026-12-25", "2026-12-28",
    "2027-01-01", "2027-03-26", "2027-03-29", "2027-05-03", "2027-05-31",
    "2027-08-30", "2027-12-27", "2027-12-28",
    "2028-01-03", "2028-04-14", "2028-04-17", "2028-05-01", "2028-05-29",
    "2028-08-28", "2028-12-25", "2028-12-26"
  ];
  var CUTOFF_MINUTES = 15 * 60;

  var londonClock = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23"
  });
  var longDate = new Intl.DateTimeFormat("en-GB", {
    timeZone: "UTC",
    weekday: "long",
    day: "numeric",
    month: "long"
  });
  var weekdayName = new Intl.DateTimeFormat("en-GB", { timeZone: "UTC", weekday: "long" });

  function londonNow(now) {
    var parts = {};
    londonClock.formatToParts(now).forEach(function (part) {
      parts[part.type] = part.value;
    });
    return {
      day: parts.year + "-" + parts.month + "-" + parts.day,
      minutes: Number(parts.hour) * 60 + Number(parts.minute)
    };
  }

  function toDate(day) {
    var p = day.split("-");
    return new Date(Date.UTC(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 12));
  }

  function addDays(day, count) {
    var date = toDate(day);
    date.setUTCDate(date.getUTCDate() + count);
    return date.toISOString().slice(0, 10);
  }

  function isWorkingDay(day) {
    var weekday = toDate(day).getUTCDay();
    return weekday >= 1 && weekday <= 5 && BANK_HOLIDAYS.indexOf(day) === -1;
  }

  function nextWorkingDay(day) {
    var next = addDays(day, 1);
    while (!isWorkingDay(next)) next = addDays(next, 1);
    return next;
  }

  function addWorkingDays(day, count) {
    var next = day;
    for (var i = 0; i < count; i++) next = nextWorkingDay(next);
    return next;
  }

  // data-ts-promise-days: working days from dispatch to delivery (1 = next day).
  function forDays(state, days) {
    if (!(days > 1)) return state;
    var copy = {};
    for (var key in state) copy[key] = state[key];
    copy.delivery = addWorkingDays(state.dispatch, days);
    return copy;
  }

  function compute(now) {
    var london = londonNow(now || new Date());
    var open = isWorkingDay(london.day) && london.minutes < CUTOFF_MINUTES;
    var dispatch = open ? london.day : nextWorkingDay(london.day);
    return {
      today: london.day,
      open: open,
      minutesLeft: open ? CUTOFF_MINUTES - london.minutes : 0,
      dispatch: dispatch,
      delivery: nextWorkingDay(dispatch)
    };
  }

  function fill(template, values) {
    return String(template || "").replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function dayLabel(day, today, strings, named) {
    if (day === today) return strings.today;
    if (day === addDays(today, 1)) return strings.tomorrow;
    return named ? weekdayName.format(toDate(day)) : longDate.format(toDate(day));
  }

  function datedLabel(day, today, strings) {
    var date = longDate.format(toDate(day));
    if (day === addDays(today, 1)) return strings.tomorrow + ", " + date;
    return date;
  }

  function countdown(minutes, strings) {
    var hours = Math.floor(minutes / 60);
    var mins = minutes % 60;
    var parts = [];
    if (hours) parts.push(fill(hours === 1 ? strings.hour : strings.hours, { n: hours }));
    if (mins || !hours) parts.push(fill(mins === 1 ? strings.minute : strings.minutes, { n: mins }));
    return parts.join(" ");
  }

  function sentence(kind, state, strings) {
    var template = strings[kind + (state.open ? "_open" : "_closed")];
    if (!template) return "";
    return fill(template, {
      countdown: countdown(state.minutesLeft, strings),
      delivery: dayLabel(state.delivery, state.today, strings, false),
      delivery_dated: datedLabel(state.delivery, state.today, strings),
      dispatch: dayLabel(state.dispatch, state.today, strings, true)
    });
  }

  var strings = null;

  function readStrings() {
    var config = document.querySelector("[data-ts-promise-config]");
    if (!config) return null;
    try {
      return JSON.parse(config.textContent);
    } catch (error) {
      return null;
    }
  }

  function render() {
    strings = strings || readStrings();
    if (!strings) return;
    var state = compute(new Date());
    document.querySelectorAll("[data-ts-promise]").forEach(function (element) {
      var target = element.querySelector("[data-ts-promise-text]");
      var kind = element.getAttribute("data-ts-promise");
      var baseKind = kind;
      if (element.getAttribute("data-ts-promise-service") === "generic" && strings[kind + "_generic_open"]) {
        kind += "_generic";
      }
      var days = Number(element.getAttribute("data-ts-promise-days"));
      var text = sentence(kind, forDays(state, days), strings);
      if (!target || !text) return;
      if (baseKind === "summary" && element.getAttribute("data-ts-promise-later") === "true") {
        text += " " + strings.summary_split;
      }
      if (target.textContent !== text) target.textContent = text;
    });
  }

  window.TSDeliveryPromise = { compute: compute, forDays: forDays, sentence: sentence, render: render };

  if (typeof document === "undefined") return;

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      render();
    }, 100);
  }

  function start() {
    render();
    setInterval(render, 30000);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
